export default {
    InternalSalesOrderDetailsSearchTable: {
        provider: 'Carrier',
        totalPrice: 'Total Shipping Fee',
        totalGst: 'Tax Fee',
        freightCharge: 'Shipping Fee',
        fuelCharge: 'Fuel surcharge',
        labelType: 'Shipping method',
        labelColour: 'Shipping type',
        responseCode: 'Sourcing Status',
        failReason: 'Failure Reason',
        creationDate: 'Date',
        status: 'status',
        push: 'Re push',
        Fix: 'Fix Order Issue',
        Select: 'Select Fix Method',
        Requote: 'Requote',
        Choose: 'Choose Courier',
        Confirm: 'Confirm update to order ',

        providerss: 'Courier Service Name',
        totalPricess: 'Carrier logistics business',
    }
};
